import React from "react";
// import Button from "@material-ui/core/Button";
// import Dialog from "@material-ui/core/Dialog";
// import DialogActions from "@material-ui/core/DialogActions";
// import DialogContent from "@material-ui/core/DialogContent";
// import DialogContentText from "@material-ui/core/DialogContentText";
// import DialogTitle from "@material-ui/core/DialogTitle";
import { Modal, Button } from "react-bootstrap";

function MyDialog(props) {
  return (
    <>
      <Modal show={props.open} onHide={props.handleClose}>
        <Modal.Header closeButton>
          <Modal.Title style={{ fontFamily: "var(--theme-font-family-body)", fontWeight: 600, color: "var(--theme-color-ink)" }}>
            {props.dialogTitle}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>{props.dialogText}</Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" className="btn btn-outline-secondary" onClick={props.handleClose}>
            {props.cancelBtnText}
          </Button>
          <Button variant="primary" className="btn btn-primary" onClick={props.handleDefault}>
            {props.defaultBtnText}
          </Button>
        </Modal.Footer>
      </Modal>
      {/* <Dialog
        open={props.open}
        onClose={props.handleClose}
        //PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          {props.dialogTitle}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>{props.dialogText}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={props.handleDefault} className="btn btn-primary">
            {props.defaultBtnText}
          </Button>
          <Button
            autoFocus
            onClick={props.handleClose}
            className="btn btn-secondary"
          >
            {props.cancelBtnText}
          </Button>
        </DialogActions>
      </Dialog> */}
    </>
  );
}

export default MyDialog;
